import { BrowserUtils } from './siteUtils'

const postToParent = (data) => {
    try {
        console.log('ICO Post to Parent:', data)
        BrowserUtils.postMessage(JSON.stringify({ ...data, source: 'ico-funnel' }), '*')
    } catch (error) {
        console.error('Post to parent failed:', error)
    }
}

export const handleOfferSubmitSuccess = (eventData) => {
    try {
        // Extract leadForm data from OfferSubmitSuccess event
        const leadForm = eventData?.leadForm

        if (!leadForm || leadForm.type !== 'CustomTagEvent') {
            return // No leadForm data or not a CustomTagEvent, skip processing
        }

        postToParent({
            type: 'customTagEvent',
            eventName: leadForm.eventName,
            eventAction: leadForm.eventAction,
            attributes: leadForm.attributes
        })
    } catch (error) {
        console.error('OfferSubmitSuccess error:', error)
        postToParent({ type: 'error', error: error.message })
    }
}

export const handlePostToParentError = (eventData) => {
    console.error('ICO Post-to-Parent Error:', eventData?.error)
    postToParent({ type: 'error', error: eventData?.error })
}
